"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Level3EventName = void 0;
var Level3EventName;
(function (Level3EventName) {
    Level3EventName["PLACE_ORGANISM_IN_TILE"] = "placeOrganismInTile";
    Level3EventName["REMOVE_ORGANISM_FROM_TILE"] = "removeOrganismFromTile";
    Level3EventName["CONNECT_TILES"] = "connectTiles";
    Level3EventName["DISCONNECT_TILES"] = "disconnectTiles";
    Level3EventName["SUBMIT_TO_TEACHER"] = "submitToTeacher";
    Level3EventName["TEACHER_GRADED"] = "teacherGraded";
})(Level3EventName = exports.Level3EventName || (exports.Level3EventName = {}));
//# sourceMappingURL=Level3EventName.js.map